import { queryOptions } from "@tanstack/react-query";
import { mockDiseaseStats, mockReviewTypeStats } from "./mocks/statsMock";

// Mock data — there is no backend /stats endpoint yet.

export const getDiseaseStatsQuery = () => queryOptions({
    queryKey: ['stats', 'list'],
    queryFn: async () => mockDiseaseStats,
    staleTime: 20 * 1000
});

export const getReviewTypeStatsQuery = () => queryOptions({
    queryKey: ['stats', 'review-types'],
    queryFn: async () => mockReviewTypeStats,
    staleTime: 20 * 1000,
});
